import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { ExtensionTypes } from 'generated/graphql-types';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { ExtensionTypeOption } from 'src/app/pages/extension-register/models/extension-type-option.interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { extensionTypeOptionActions } from '../state/extension-type-option.actions';
import { extensionTypeOptionSelectors } from '../state/extension-type-option.reducer';

@Directive({
    selector: '[ndtExtensionTypeSelect]',
    standalone: false
})
export class ExtensionTypeSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   @Input() extensionTypesToInclude: ExtensionTypes[];

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<ExtensionTypeOption>,
      private statusService: NgrxEagerSelectService<AppState, ExtensionTypeOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] = [];
      if (this.extensionTypesToInclude) {
         staticFilterOverride.push(`Name in (${this.extensionTypesToInclude.join(',')})`);
      }

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            extensionTypeOptionActions,
            extensionTypeOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('extensionTypeId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
